import React from 'react';
const FACEBOOK_APP_ID = '1194427975802856';
const REDIRECT_URI =
  window.location.hostname === 'localhost'
    ? 'http://localhost:3001/meta-auth-callback'
    : 'https://loyaltap.flexpayz.com/meta-auth-callback';

const ConnectMetaPage = () => {
  const handleMetaLogin = () => {
    const scope = [
      'email',
      'pages_read_engagement',
      'pages_manage_posts',
      'instagram_basic',
      'instagram_manage_comments'
    ].join(',');

    const authUrl = `https://www.facebook.com/v19.0/dialog/oauth?client_id=${FACEBOOK_APP_ID}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}&scope=${scope}&response_type=code`;

    window.location.href = authUrl;
  };

  return (
    <div className="connect-meta-container">
      <h2>Connect Your Facebook / Instagram Account</h2>
      <p>This allows LoyalTap to analyze your comments using AI.</p>
      <button onClick={handleMetaLogin}>
        Connect Facebook / Instagram
      </button>
    </div>
  );
};

export default ConnectMetaPage;